import { useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import LinearProgress from "@material-ui/core/LinearProgress";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import { ActiveChainFilter, ActiveGroup } from "./components/Chain";
import { FEATURES_QUERY } from "./components/Features";
import { MoralisFullIcon } from "./components/Logos/Moralis";
import { STATUS_QUERY, useSubscribeToMore } from "./components/Resource";
import { Switch, Route } from "react-router-dom"
import { ThemeSwitch } from "./themes";
import { ResourceList } from "./routes/Resources"
import { FeatureList } from "./routes/Features"

function App() {
  // const [chainId, setChainId] = useState("");
  const [group, setGroup] = useState("");
  // const features = useQuery(FEATURES_QUERY);
  // const status = useQuery(STATUS_QUERY);

  // useSubscribeToMore();

  return (
    <>
      {/* {features.loading || status.loading ? <LinearProgress /> : null} */}
      <Toolbar>
        <MoralisFullIcon style={{ height: 30, marginRight: 8 }} />
        <Typography variant="h6">Status</Typography>
        <Box flexGrow={1} />
        <ThemeSwitch />
      </Toolbar>
      <Box my={2}>
        <Container>
          {/* <ActiveChainFilter chainId={chainId} setChainId={setChainId} /> */}
          <ActiveGroup group={group} setGroup={setGroup} />
          <Switch>
            <Route path="/" exact>
              <ResourceList group={group} />
            </Route>
            {/* <Route path="/features" exact>
              <FeatureList group={group} />
            </Route> */}
          </Switch>
        </Container>
      </Box>
    </>
  );
}

export default App;
